export const incomingAiStatusLabel = (doc) => {
  if (doc?.sentToERP) return 'Передано в ERP';
  if (doc?.isDone) return 'Готова';
  if (doc?.recognizeStatus === 'error') return 'Помилка AI';
  if (doc?.recognizeStatus === 'recognizing') return 'Розпізнавання';
  if (doc?.recognizeStatus === 'structuring_ai') return 'Формування JSON';
  if (doc?.recognizeStatus === 'matching') return 'Пошук товарів';
  if (doc?.recognizeStatus === 'needsReview') return 'Потрібна перевірка';
  if (doc?.recognizeStatus === 'recognized') return 'Розпізнано';
  return 'Чернетка';
};

export const incomingAiStatusColor = (doc) => {
  if (doc?.sentToERP) return '#607d8b';
  if (doc?.isDone) return '#2e7d32';
  if (doc?.recognizeStatus === 'error') return '#d32f2f';
  if (doc?.recognizeStatus === 'recognizing') return '#1976d2';
  if (doc?.recognizeStatus === 'structuring_ai') return '#1976d2';
  if (doc?.recognizeStatus === 'matching') return '#1976d2';
  if (doc?.recognizeStatus === 'needsReview') return '#f9a825';
  return '#bdbdbd';
};

export const unresolvedLinesCount = (doc) =>
  (doc?.products || []).filter((line) => !line.productId && line.matchStatus !== 'matched').length;

export const isIncomingAiBusy = (doc) =>
  ['recognizing', 'structuring_ai', 'matching'].includes(doc?.recognizeStatus);

export const hasIncomingAiOcr = (doc) => {
  const ocr = doc?.aiRawData?.ocr;
  if (!ocr) return false;
  if (Array.isArray(ocr.pages) && ocr.pages.length) return true;
  return Boolean(ocr.text);
};

export const fileToImagePayload = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result || '');
      resolve({
        filename: file.name,
        mimeType: file.type || 'image/jpeg',
        base64: result.replace(/^data:[^;]+;base64,/i, ''),
      });
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
